(() => {
    let activeWrapper = null,
        activeController = null,
        activeIo = null,
        cachedModal = null,
        cachedParent = null,
        isClosing = false;

    function fetchModalContent(triggerEl, signal) {
        const req = JSON.parse(triggerEl.dataset.modal);
        const body = new URLSearchParams(req);
        const baseUrl = typeof site_url !== 'undefined' ? site_url : '/';

        return fetch(baseUrl + "ajax/functions.php", {
            method: "POST",
            body,
            signal
        }).then(res => {
            if (!res.ok) throw new Error("Network error: " + res.status);
            return res.json().then(obj => (obj.html ? obj.html : obj));
        });
    }

    function closeModal() {
        if (!activeWrapper || isClosing) return;
        isClosing = true;

        activeWrapper.setAttribute("aria-expanded", "false");

        if (activeController) activeController.abort();
        if (activeIo) activeIo.disconnect();

        activeWrapper.classList.add("closing");

        const handleAnimationEnd = (e) => {
            if (e.target !== activeWrapper) return;
            activeWrapper.removeEventListener("animationend", handleAnimationEnd);

            if (cachedModal && cachedParent) {
                cachedModal.setAttribute("hidden", "");
                cachedParent.appendChild(cachedModal);
            }

            activeWrapper.remove();

            activeWrapper = null;
            activeController = null;
            activeIo = null;
            cachedModal = null;
            cachedParent = null;
            isClosing = false;
        };

        activeWrapper.addEventListener("animationend", handleAnimationEnd);
    }

    document.addEventListener("click", (e) => {
        if (activeWrapper && (e.target === activeWrapper || e.target.closest(".modal-close"))) {
            closeModal();
            return;
        }

        const trigger = e.target.closest("[data-modal]");
        if (!trigger || activeWrapper) return;

        if (trigger.tagName === "A") e.preventDefault();

        const isInline = trigger.dataset.modal.startsWith("#");
        const isSidePanel = trigger.dataset.modalType === "side-panel";

        activeController = new AbortController();

        activeWrapper = document.createElement("div");
        activeWrapper.id = "modal-wrapper";
        activeWrapper.className = "modal-wrapper" + (isSidePanel ? " modal-wrapper--side-panel" : "");
        activeWrapper.setAttribute("data-lenis-prevent", "true");
        activeWrapper.setAttribute("data-focus-trap", "true");
        activeWrapper.setAttribute("aria-busy", "true");
        document.body.appendChild(activeWrapper);

        const holder = document.createElement("div");
        holder.className = "modal-holder";

        const head = document.createElement("div");
        head.className = "modal-head container content-overlap js-offset";
        head.dataset.target = activeWrapper.id;

        const button = document.createElement("button");
        button.type = "button";
        button.setAttribute("aria-label", "Close Modal");
        button.className = "modal-close subtitle d-block";
        button.textContent = "Close";
        button.dataset.action = "close";

        head.appendChild(button);

        if (trigger.dataset.heading) {
            const heading = document.createElement("h2");
            heading.className = "subtitle subtitle--large text-center";
            heading.textContent = trigger.dataset.heading;
            head.appendChild(heading);
        }

        const content = document.createElement("div");
        content.className = "modal-content container";

        holder.appendChild(head);
        holder.appendChild(content);

        if (!isSidePanel) {
            activeIo = new IntersectionObserver(([entry]) => {
                if (!entry.isIntersecting && entry.time > 100) closeModal();
            });
        }

        const finalizeModal = () => {
            if (isClosing) return;

            activeWrapper.appendChild(holder);
            activeWrapper.removeAttribute("aria-busy");
            activeWrapper.setAttribute("aria-expanded", "true");

            if (activeIo) requestAnimationFrame(() => activeIo.observe(holder));
        };

        if (isInline) {
            cachedModal = document.getElementById(trigger.dataset.modal.substring(1));
            if (cachedModal) {
                cachedParent = cachedModal.parentElement;
                content.appendChild(cachedModal);
                cachedModal.removeAttribute("hidden");
                finalizeModal();
            }
        } else {
            fetchModalContent(trigger, activeController.signal)
                .then(html => {
                    content.innerHTML = html;
                    finalizeModal();
                })
                .catch(err => {
                    if (err.name !== 'AbortError') console.error("Modal Fetch Error:", err);
                    closeModal();
                });
        }
    });
})();